import { apiClient } from './client.js';
import type {
  CreateTenantUserInput,
  TenantUser,
  UpdateTenantUserInput,
  UserRole,
} from '@atomfit/shared';
import type { PaginatedResult } from '../types/index.js';

function tenantHeaders(tenantSlug?: string) {
  return tenantSlug ? { headers: { 'X-Tenant-ID': tenantSlug } } : undefined;
}

export const usersApi = {
  adminList: (
    params: {
      registeredFrom?: string;
      registeredTo?: string;
      q?: string;
      role?: UserRole | 'CUSTOMER';
      tenantSlug?: string;
      page?: number;
    } = {},
  ) => apiClient.get<PaginatedResult<TenantUser>>('/admin/users', { params }),

  list: (
    params: {
      registeredFrom?: string;
      registeredTo?: string;
      q?: string;
      role?: UserRole | 'CUSTOMER';
      page?: number;
      tenantSlug?: string;
    } = {},
  ) => {
    const { tenantSlug, ...query } = params;
    return apiClient.get<PaginatedResult<TenantUser>>('/owner/users', {
      params: query,
      ...tenantHeaders(tenantSlug),
    });
  },

  create: (data: CreateTenantUserInput, tenantSlug?: string) =>
    apiClient.post<TenantUser>('/owner/users', data, tenantHeaders(tenantSlug)),

  update: (membershipId: string, data: UpdateTenantUserInput, tenantSlug?: string) =>
    apiClient.put<TenantUser>(`/owner/users/${membershipId}`, data, tenantHeaders(tenantSlug)),

  remove: (membershipId: string, tenantSlug?: string) =>
    apiClient.delete(`/owner/users/${membershipId}`, tenantHeaders(tenantSlug)),
};
